<!-- ReusableAlert.vue -->
<template>
  <div
    class="flex font-semibold justify-between p-4 mb-4 text-sm rounded-lg border"
    :style="{
      backgroundColor: lighter_color,
      borderColor: darker_color
    }"
  >
    <div>
      <p>{{ message }}</p>
      <slot></slot>
    </div>
    <div>
      <Multi_Button
        :button-char="'X'"
        :text-size="'text-md'"
        :border="darker_color"
        :background-color="lighter_color"
        :text-color="darker_color"
        :emission="'click'"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
import Multi_Button from '@/components/widgetcomponents/Multi_Button.vue'
import {changeAlpha} from "@/utils/common";

export default {
  components: {Multi_Button},
  props: {
    message: {
      type: String,
      default: 'No message provided'
    },
    color: {
      type: String,
      default: '#DEDEDE'
    }
  },
  emits: ['close'],
  data() {
    return {
    }
  },
  computed: {
    darker_color() {
      return this.color
    },
    lighter_color() {
      return changeAlpha(this.color,0.3)
    }
  },
}
</script>
